/* AUTO-GENERATED by scripts/sync-landing.mjs from scripts/data-sources/acgme-minimums/index.json + artifacts/web/src/data/specialties.ts.
   Do not edit by hand — run `pnpm --filter @workspace/web sync:landing` instead. */
// The route keys for the ACGME case-minimums library, and nothing else:
// App.tsx imports this into the chunk every route loads. The tables are in
// acgme-minimums-<code>.ts and the light index in acgme-catalog.ts.

/** One per specialty, in ACGME code order: /acgme-case-minimums/<slug>. The
 *  slug is the ACGME name lowercased, each run of other characters a hyphen. */
export const ACGME_MINIMUMS_SLUGS = [
  "anesthesiology",
  "adult-cardiothoracic-anesthesiology",
  "pediatric-anesthesiology",
  "obstetric-anesthesiology",
  "anesthesiology-critical-care-medicine",
  "regional-anesthesiology-and-acute-pain-medicine",
  "pediatric-cardiac-anesthesiology",
  "neurological-surgery",
  "neuroendovascular-intervention",
  "obstetrics-and-gynecology",
  "urogynecology-and-reconstructive-pelvic-surgery",
  "gynecologic-oncology",
  "maternal-fetal-medicine",
  "reproductive-endocrinology-and-infertility",
  "complex-family-planning",
  "ophthalmology",
  "ophthalmic-plastic-and-reconstructive-surgery",
  "orthopaedic-surgery",
  "adult-reconstructive-orthopaedics",
  "foot-and-ankle-orthopaedics",
  "hand-surgery-orthopaedic-surgery",
  "pediatric-orthopaedics",
  "orthopaedic-surgery-of-the-spine",
  "orthopaedic-sports-medicine",
  "orthopaedic-trauma",
  "musculoskeletal-oncology",
  "otolaryngology-head-and-neck-surgery",
  "neurotology",
  "pediatric-otolaryngology",
  "plastic-surgery-independent",
  "craniofacial-surgery-craniofacial-plastic-surgery",
  "plastic-surgery-integrated",
  "surgery-of-the-hand-plastic-surgery",
  "interventional-radiology-independent",
  "interventional-radiology-integrated",
  "vascular-and-interventional-radiology",
  "general-surgery",
  "surgical-critical-care",
  "hand-surgery-surgery",
  "pediatric-surgery",
  "complex-general-surgical-oncology",
  "vascular-surgery-independent",
  "vascular-surgery-integrated",
  "thoracic-surgery-independent",
  "thoracic-surgery-integrated",
  "congenital-cardiac-surgery",
  "urology",
  "pediatric-urology",
  "urogynecology-and-reconstructive-pelvic-surgery-urology",
  "pain-medicine"
] as const;

export const ACGME_MINIMUMS_CODE_BY_SLUG: Readonly<Record<string, string>> = {
  "anesthesiology": "040",
  "adult-cardiothoracic-anesthesiology": "041",
  "pediatric-anesthesiology": "042",
  "obstetric-anesthesiology": "043",
  "anesthesiology-critical-care-medicine": "045",
  "regional-anesthesiology-and-acute-pain-medicine": "046",
  "pediatric-cardiac-anesthesiology": "047",
  "neurological-surgery": "160",
  "neuroendovascular-intervention": "163",
  "obstetrics-and-gynecology": "220",
  "urogynecology-and-reconstructive-pelvic-surgery": "221",
  "gynecologic-oncology": "225",
  "maternal-fetal-medicine": "230",
  "reproductive-endocrinology-and-infertility": "235",
  "complex-family-planning": "236",
  "ophthalmology": "240",
  "ophthalmic-plastic-and-reconstructive-surgery": "241",
  "orthopaedic-surgery": "260",
  "adult-reconstructive-orthopaedics": "261",
  "foot-and-ankle-orthopaedics": "262",
  "hand-surgery-orthopaedic-surgery": "263",
  "pediatric-orthopaedics": "265",
  "orthopaedic-surgery-of-the-spine": "267",
  "orthopaedic-sports-medicine": "268",
  "orthopaedic-trauma": "269",
  "musculoskeletal-oncology": "270",
  "otolaryngology-head-and-neck-surgery": "280",
  "neurotology": "286",
  "pediatric-otolaryngology": "288",
  "plastic-surgery-independent": "360",
  "craniofacial-surgery-craniofacial-plastic-surgery": "361",
  "plastic-surgery-integrated": "362",
  "surgery-of-the-hand-plastic-surgery": "363",
  "interventional-radiology-independent": "415",
  "interventional-radiology-integrated": "416",
  "vascular-and-interventional-radiology": "427",
  "general-surgery": "440",
  "surgical-critical-care": "442",
  "hand-surgery-surgery": "443",
  "pediatric-surgery": "445",
  "complex-general-surgical-oncology": "446",
  "vascular-surgery-independent": "450",
  "vascular-surgery-integrated": "451",
  "thoracic-surgery-independent": "460",
  "thoracic-surgery-integrated": "461",
  "congenital-cardiac-surgery": "466",
  "urology": "480",
  "pediatric-urology": "485",
  "urogynecology-and-reconstructive-pelvic-surgery-urology": "486",
  "pain-medicine": "530"
};

export const ACGME_MINIMUMS_SLUG_BY_CODE: Readonly<Record<string, string>> = {
  "160": "neurological-surgery",
  "163": "neuroendovascular-intervention",
  "220": "obstetrics-and-gynecology",
  "221": "urogynecology-and-reconstructive-pelvic-surgery",
  "225": "gynecologic-oncology",
  "230": "maternal-fetal-medicine",
  "235": "reproductive-endocrinology-and-infertility",
  "236": "complex-family-planning",
  "240": "ophthalmology",
  "241": "ophthalmic-plastic-and-reconstructive-surgery",
  "260": "orthopaedic-surgery",
  "261": "adult-reconstructive-orthopaedics",
  "262": "foot-and-ankle-orthopaedics",
  "263": "hand-surgery-orthopaedic-surgery",
  "265": "pediatric-orthopaedics",
  "267": "orthopaedic-surgery-of-the-spine",
  "268": "orthopaedic-sports-medicine",
  "269": "orthopaedic-trauma",
  "270": "musculoskeletal-oncology",
  "280": "otolaryngology-head-and-neck-surgery",
  "286": "neurotology",
  "288": "pediatric-otolaryngology",
  "360": "plastic-surgery-independent",
  "361": "craniofacial-surgery-craniofacial-plastic-surgery",
  "362": "plastic-surgery-integrated",
  "363": "surgery-of-the-hand-plastic-surgery",
  "415": "interventional-radiology-independent",
  "416": "interventional-radiology-integrated",
  "427": "vascular-and-interventional-radiology",
  "440": "general-surgery",
  "442": "surgical-critical-care",
  "443": "hand-surgery-surgery",
  "445": "pediatric-surgery",
  "446": "complex-general-surgical-oncology",
  "450": "vascular-surgery-independent",
  "451": "vascular-surgery-integrated",
  "460": "thoracic-surgery-independent",
  "461": "thoracic-surgery-integrated",
  "466": "congenital-cardiac-surgery",
  "480": "urology",
  "485": "pediatric-urology",
  "486": "urogynecology-and-reconstructive-pelvic-surgery-urology",
  "530": "pain-medicine",
  "040": "anesthesiology",
  "041": "adult-cardiothoracic-anesthesiology",
  "042": "pediatric-anesthesiology",
  "043": "obstetric-anesthesiology",
  "045": "anesthesiology-critical-care-medicine",
  "046": "regional-anesthesiology-and-acute-pain-medicine",
  "047": "pediatric-cardiac-anesthesiology"
};

/** LIVE_SPECIALTIES' display names, in registry order: the specialties the app
 *  counts today. The library's product line is minted from this, never typed. */
export const LIVE_SPECIALTY_NAMES: readonly string[] = ["Anesthesiology","Neurological Surgery"];
